import React, { Component } from 'react';
import config from '../Config/Config';
import axios from 'axios';

class SearchForm extends Component {

  typeTimer = false;
  termsInput = null;

  state = {
    terms: '',
    resultsVisible: false,
    searchCompleted: false,
    results: [],
  };

  constructor() {
    super();
    this.termsInput = React.createRef();
    // hide the search results when the user clicks anywhere but on the results
    document.addEventListener('click', (event) => {
      if (!event.target.closest('.search__form')) {
        this.setState({ resultsVisible: false });
      }
    });
  }

  doSearch = (terms) => {
    this.setState({
      error: false,
      loading: true,
      searchCompleted: false,
      resultsVisible: true,
    });
    axios.get(config.api + '/search/' + this.props.index +'/' + terms)
      .then((response) => {
        if (response.status === 200) {
          this.setState({ results: response.data.results });
        }
      })
      .catch(() => {
        this.setState({ error: 'De zoekmachine is momenteel niet beschikbaar, probeer het later opnieuw.' });
      })
      .finally(() => {
        this.setState({
          loading: false,
          searchCompleted: true,
          resultsVisible: true,
        });
      });
  };

  handleChangeTerm = (event) => {
    const value = event.target.value;
    this.setState({ terms: value });

    clearTimeout(this.typeTimer);
    if (value.length >= 3) {
      this.typeTimer = setTimeout(() => { this.doSearch(this.state.terms) }, 250);
    }
  };

  handleKeyDownTerm = (event) => {
    if (event.type !== 'keydown' || event.keyCode !== 13) {
      return;
    }

    window.location.href = "/search?terms=" + this.state.terms;
  };

  handleClickSearch = (event) => {
    this.setState({
      results: [],
      error: '',
      resultsVisible: false
    });

    this.handleChangeTerm(event);

    event.preventDefault();
  };

  componentDidUpdate() {
    if (this.props.focusInput) {
      setTimeout(() => { this.termsInput.current.focus(); }, 10); // not sure why this hack is needed, without timeout focus doesn't work
    }
    if (this.state.error) {
      this.termsInput.current.focus();
    }
  }

  render() {
    const resultsClasses = ["search__results"];
    if (this.state.resultsVisible) {
      resultsClasses.push("search__results--visible");
    }
    if (this.state.searchCompleted && this.state.results.length === 0) {
      resultsClasses.push("search__results--empty");
    }
    if (this.state.error) {
      resultsClasses.push("search__results--error");
    }
    if (this.state.loading) {
      resultsClasses.push("search__results--loading");
    }

    let results = false;
    if (this.state.error) {
      results = <div className="message message--error">{ this.state.error }</div>;
    } else if (this.state.loading) {
      results = <div className="message message--loading">Searching...</div>;
    } else if (this.state.results.length > 0) {
      results = (
        <div>
          <div className="result__wrapper">
            {
              this.state.results.map((result) => {
                return (
                  <a href={result.url} key={result.nid} className="result">
                    <div className={'result__type result__type--' + result.type_key}>{result.type_title}</div>
                    <div className="result__title">{result.title}</div>
                    <div className="result__excerpt">
                      <span dangerouslySetInnerHTML={{__html: result.excerpt}}></span>
                    </div>
                  </a>
                );
              })
            }
          </div>
          <div className="result__show-all">
            <a href={`/search?terms=${this.state.terms}`} className="button button--primary">Show all results</a>
          </div>
        </div>
      );
    } else if (this.state.searchCompleted) {
      results = <div className="message message--empty">No results found</div>;
    }

    return (
      <div className="search__form">
        <div className="search__inputs">
          <input className="search__input" type="text" placeholder="Search..." ref={ this.termsInput } value={ this.state.terms } onChange={ this.handleChangeTerm } onKeyDown={ this.handleKeyDownTerm } />
          <button className="search__button button button--primary" onClick={ this.handleClickSearch }>Zoek</button>
        </div>
        <div className={ resultsClasses.join(' ') }>
          { results }
        </div>
      </div>
    );
  }
}

export default SearchForm;
